import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getPendingWorkOrderSignoffsForUser } from '~/monolith-api';

import type { PendingWorkOrderSignoffForUser as PendingWorkOrderSignoffForUserFromMonolith } from '~/monolith-api';

export type PendingWorkOrderSignoffForUser = Pick<
   PendingWorkOrderSignoffForUserFromMonolith,
   | 'signoffid'
   | 'date'
   | 'workorderid'
   | 'guideTitle'
   | 'guideURL'
   | 'userAvatar'
   | 'userProfile'
   | 'userid'
   | 'username'
   | 'entryid'
   | 'stepid'
   | 'isUsingSSO'
   | 'ssoApprovalUrl'
   | 'ssoRejectUrl'
>;

export type getPendingWorkOrderSignoffsForUserFromClient = {
   pendingSignoffs: PendingWorkOrderSignoffForUser[];
};

const getPendingSignoffsForUserSchema = z.object({
   userid: z.number(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { userid } = getPendingSignoffsForUserSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getPendingWorkOrderSignoffsForUser(userid, {
         apiClient: monolithClient,
      });
      res.status(200).json({
         pendingSignoffs: Object.values(result.pendingSignoffs),
      });
   },
});

export const getPendingWorkOrderSignoffsForUserFromClient = (
   userid: number
): Promise<getPendingWorkOrderSignoffsForUserFromClient> => {
   return bff()
      .post('/signoffs/getPendingWorkOrderSignoffsForUser', {
         userid,
      })
      .then(response => response.data);
};
